import { createRoutesFromElements, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navigator from "./components/Navigator";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import DeleteAccount from "./pages/DeleteAccount";
import RecipeShare from "./pages/RecipeShare";
import UserShare from "./pages/UserShare";
import OpenApp from "./pages/OpenApp";
import Connect from "./pages/Connect";
import NotFound from "./pages/NotFound";

// Shared by the browser router and the build-time pre-renderer.
export const routes = createRoutesFromElements(
  <Route element={<Navigator />}>
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="/delete-account" element={<DeleteAccount />} />
    <Route path="/connect" element={<Connect />} />
    <Route path="/open" element={<OpenApp />} />
    <Route path="/r/:recipeId" element={<RecipeShare />} />
    <Route path="/u/:userId" element={<UserShare />} />
    <Route path="" element={<Home />} />
    <Route path="*" element={<NotFound />} handle={{ notFound: true }} />
  </Route>
);
